import { DeviceWidthDriver } from './DeviceWidthDriver/DeviceWidthDriver.tsx';

export const NullComponents = () => (
  <>
    <DeviceWidthDriver />
  </>
);
